export default "<footer role=\"contentinfo\">\n    <p class=\"k-copyright\">{{'FOOTER.COPYRIGHT' | translate}}</p>\n</footer>\n";